import {
  AccreditedGender,
  AppointmentType,
  accreditedGenders,
  appointmentTypes
} from '@/modules/accredited-establishments/api/types'

type EnumParamValue = string | string[] | null | undefined

/*
 * Fonte unica da guarda "string da url -> membro do enum". Um valor fora do
 * enum e descartado em vez de propagado: o servico responde 400 a um balde
 * desconhecido, e uma url editada a mao derrubaria a busca inteira em vez de so
 * ignorar o filtro invalido.
 *
 * Um param repetido (`?genero=FEMALE&genero=MALE`) chega como array no SSR e
 * como primeiro valor no client (`URLSearchParams.get`). Resolver sempre o
 * primeiro elemento mantem a cache key dos dois lados igual, sem refetch extra
 * na hidratacao.
 */
const parseEnumParam = <T extends string>(
  value: EnumParamValue,
  allowed: readonly T[]
): T | undefined => {
  const single = Array.isArray(value) ? value[0] : value

  return allowed.find(option => option === single)
}

const toAccreditedGender = (
  value: EnumParamValue
): AccreditedGender | undefined => parseEnumParam(value, accreditedGenders)

const toAppointmentType = (
  value: EnumParamValue
): AppointmentType | undefined => parseEnumParam(value, appointmentTypes)

export { parseEnumParam, toAccreditedGender, toAppointmentType }
export type { EnumParamValue }
